import { IReportCatalogEntry } from "./reportCatalog.types";

export function reportEntry(
  code: string,
  description: string,
  title?: string,
  enabled = true,
): IReportCatalogEntry {
  return {
    code,
    description,
    enabled,
    ...(title ? { title } : {}),
  };
}
